import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { checkSession } from "../../../store/slices/sessionSlice";
import AdminLoader from "../../common/loader/AdminLoader";

const RedirectIfAuth = ({ children }) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.session);
  const loading = useSelector((state) => state.session.loading);
  const [checked, setChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only check session once on mount
    dispatch(checkSession());
    setChecked(true);
    // eslint-disable-next-line
  }, []);

  if (!checked || loading) {
    // Show loading while checking session
    return (
      <div className="text-center pt-8">
        <AdminLoader isLoading={true} />
      </div>
    );
  }

  if (session) {
    // Already authenticated, redirect to dashboard
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  // Not authenticated, render children (login/forgot pages)
  return children;
};

export default RedirectIfAuth;
